import Card1 from './Card_1';
const Content_Card_1 = () => {
  return <Card1 />;
};
export default Content_Card_1;
